import { render } from "./DynamicDialog.vue?vue&type=template&id=35a65644"
import script from "./DynamicDialog.vue?vue&type=script&lang=js"
export * from "./DynamicDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__